import { notifyError } from 'Utils/errorNotifications'

const asyncHandler = (asyncFn, errorCallback) => (
  async (...args) => {
    try {
      return await asyncFn(...args)
    } catch (error) {
      if (errorCallback) return errorCallback(error, ...args)

      notifyError(error)
    }
  }
)

export { asyncHandler }
